// Issue #185 — the one sentence both platforms' "Remove <name>?" confirmations show,
// built from the pure planner's counts. Lives here, beside `errorToMessage`, so web and
// mobile state the same consequences rather than drifting apart.
export const participantRemovalSummary = (preview, displayName) => {
    const parts = [];
    if (preview.deletes > 0) {
        const s = preview.deletes !== 1 ? "s" : "";
        parts.push(`${preview.deletes} row${s} assigned only to ${displayName} will be deleted`);
    }
    if (preview.reassigned > 0) {
        const s = preview.reassigned !== 1 ? "s" : "";
        parts.push(`${preview.reassigned} shared row${s} will stay, without ${displayName}`);
    }
    if (parts.length === 0)
        return "Nothing is assigned only to them, so no rows change.";
    return parts.join("; ") + ".";
};
//# sourceMappingURL=participantRemovalSummary.js.map